"use client";
import { useEffect } from "react";
import { useFlags } from "@stadium/services/launch-darkly";

import { PaymentError } from "@stadium/services/error-reporting/utils";
import { serializeStripeError } from "@stadium/services/stripe";
import { showError, clearAllToasts, PAYMENT_ERROR_CONFIG } from "@stadium/services/react-toastify";

import { MailToConcierge } from "@stadium/ui/src/components/mail-to";
import AddCardForm from "@stadium/ui/src/components/add-card";

import { orderServiceInstance as axiosInstance } from "@stadium/services/axios";

import { STRIPE_API_KEY } from "@stadium/checkout/src/constants/app-defaults";

import { displayStripeOriginalPaymentErrorMessageFlag } from "@stadium/services/launch-darkly/constants";

import styles from "./main.module.scss";

const emptyArr = [];

const CardCreate = ({ data }) => {
  const { onSuccess, bodyWrapperClasses = "", actionButtonsWrapper = "", ...rest } = data;
  const { [displayStripeOriginalPaymentErrorMessageFlag]: showStripeOriginalErrorMessage } =
    useFlags();

  useEffect(() => {
    clearAllToasts();
  }, emptyArr);

  return (
    <AddCardForm
      apiClient={axiosInstance}
      stripeKey={STRIPE_API_KEY}
      onPaymentError={(error) => {
        const { displayErrorMessageHtml } = serializeStripeError({
          error,
          MailTo: MailToConcierge,
          showOriginalMessage: showStripeOriginalErrorMessage,
        });
        showError(displayErrorMessageHtml, "", PAYMENT_ERROR_CONFIG);
        return new PaymentError(error);
      }}
      onSuccess={(card) => {
        onSuccess(card);
      }}
      classes={{
        bodyWrapper: `${styles.cardAddForm} ${bodyWrapperClasses}`,
        input: `${styles.formControlInput}`,
        inputLabel: `${styles.labelCC} label-cc`,
        actionButtonsWrapper: actionButtonsWrapper,
      }}
      showError={showError}
      clearErrors={clearAllToasts}
      {...rest}
    />
  );
};

export default CardCreate;
